import type {PayloadAction} from "@reduxjs/toolkit/react";
import {createSlice} from "@reduxjs/toolkit/react";
import {type AuthState, type SpacePublicInfo, type UserFullInfo, type UserRole} from "@src/features/auth/auth-models";

export const AUTH_SLICE_NAME: string = "auth";

function createDefaultState(): AuthState {
	return {
		userFullInfo: null,
		userRoles: [],
		spacesPublicInfo: []
	} satisfies AuthState;
}

export const authSlice = createSlice({
	name: AUTH_SLICE_NAME,
	initialState: createDefaultState(),
	reducers: {
		setAuthState(_state, action: PayloadAction<AuthState>): AuthState {
			return action.payload;
		},
		clearAuthState(_state): AuthState {
			return createDefaultState();
		}
	},
	selectors: {
		selectIsLoggedIn(state): boolean {
			return state.userFullInfo != null;
		},
		selectUserFullInfo(state): UserFullInfo | null {
			return state.userFullInfo
		},
		selectUserRoles(state): UserRole[] {
			return state.userRoles
		},
		selectSpacesPublicInfo(state): SpacePublicInfo[] {
			return state.spacesPublicInfo
		},
	}
});

export const authReducer = authSlice.reducer;

export const {setAuthState, clearAuthState} = authSlice.actions;

export const {
	selectIsLoggedIn,
	selectUserFullInfo,
	selectUserRoles,
	selectSpacesPublicInfo,
} = authSlice.selectors;
